import { IQueryParams } from '@app/shared/interfaces/queryParams';

const defaultQueryParams: IQueryParams = {
  searchFields: 'profileId,orgName,fullName,email',
  filter: "'inactive':false",
  searchValues: '',
  sort: 'fullName',
  selections: '',
  doCount: false,
  pageIndex: 1,
};

export { defaultQueryParams };

export const USER_DATA = 'USER:LOGINDATA';
export const LAST_SELECTED_ORG = 'USER:LAST-SELECTED-ORG';
